import * as React from 'react';
import {useDispatch} from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PublicIcon from '@mui/icons-material/Public';
import {PlaylistVisibility, setPlaylistVisibility} from '../../../../store/slices/userPlaylists/reducers';
import {PlaylistShareButton} from '../playlistShareButton/PlaylistShareButton';
import styles from './PlaylistShareControls.module.scss';

interface PlaylistShareControlsProps {
    playlistId: string;
    playlistName: string;
    visibility: PlaylistVisibility;
}

export const PlaylistShareControls: React.FC<PlaylistShareControlsProps> = ({playlistId, playlistName, visibility}) => {
    const dispatch = useDispatch();
    const isPublic = visibility === 'public';

    const toggleVisibility = () => {
        dispatch(setPlaylistVisibility({
            id: playlistId,
            visibility: isPublic ? 'private' : 'public',
        }));
    };

    return (
        <>
            <Tooltip title={isPublic ? 'Public — tap to make private' : 'Private — tap to make public'}>
                <IconButton
                    onClick={toggleVisibility}
                    className={isPublic ? styles.shareControls__toggleOn : styles.shareControls__toggleOff}
                    aria-label={isPublic ? 'Make playlist private' : 'Make playlist public'}
                >
                    {isPublic ? <PublicIcon/> : <LockOutlinedIcon/>}
                </IconButton>
            </Tooltip>
            {isPublic && (
                <PlaylistShareButton
                    playlistId={playlistId}
                    playlistName={playlistName}
                    playlistType="user"
                />
            )}
        </>
    );
};
